(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.querySelector("[data-cart-drawer]");

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute("data-open", "");
    drawer.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.removeAttribute("data-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.querySelectorAll("[data-cart-toggle]").forEach(function (btn) {
    btn.addEventListener("click", openDrawer);
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (el) {
    el.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* ---------- AJAX add-to-cart for every product form on the page ---------- */
  document.querySelectorAll("form[action*='/cart/add']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector("[type='submit']");
      var originalText = submitBtn ? submitBtn.textContent : "";

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Adding…";
      }

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch("/cart.js");
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.textContent = cart.item_count;
          });
          renderDrawerFromCart(cart);
          openDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  });

  function renderDrawerFromCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector("[data-cart-items]");
    var subtotal = drawer.querySelector(".cart-drawer__subtotal");
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items
        .map(function (item) {
          var variant = item.variant_title && item.variant_title !== "Default Title"
            ? '<p class="cart-drawer__item-variant">' + item.variant_title + "</p>"
            : "";
          var img = item.image
            ? '<img src="' + item.image + '" alt="" width="80" height="80">'
            : "";
          return (
            '<div class="cart-drawer__item">' +
            img +
            '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + item.product_title + "</p>" +
            variant +
            '<p class="cart-drawer__item-price">' + item.quantity + " &times; " + formatMoney(item.price) + "</p>" +
            "</div></div>"
          );
        })
        .join("");
    }

    if (subtotal) {
      subtotal.textContent = "Subtotal: " + formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ---------- Product page: image swatches + thumbnails ---------- */
  document.querySelectorAll(".product-page").forEach(function (page) {
    var mainImage = page.querySelector("[data-product-main-image]");
    var variantInput = page.querySelector("[data-product-variant-id]");
    var priceEl = page.querySelector("[data-product-price]");
    var addBtn = page.querySelector("[data-product-add-btn]");

    function selectSwatch(swatch) {
      var group = swatch.closest(".swatch-grid");
      if (group) {
        group.querySelectorAll(".swatch").forEach(function (el) {
          el.classList.remove("is-selected");
        });
        swatch.classList.add("is-selected");
      }

      var option = swatch.closest(".product-page__option");
      if (option) {
        var label = option.querySelector("[data-option-value-label]");
        if (label) label.textContent = swatch.getAttribute("data-value");
      }

      var image = swatch.getAttribute("data-image");
      if (image && mainImage) mainImage.setAttribute("src", image);

      var variantId = swatch.getAttribute("data-variant-id");
      if (variantId && variantInput) variantInput.value = variantId;

      var price = swatch.getAttribute("data-price");
      if (price && priceEl) priceEl.textContent = price;

      if (addBtn) {
        var unavailable = swatch.classList.contains("is-unavailable");
        addBtn.disabled = unavailable;
        addBtn.textContent = unavailable ? "Sold out" : "Add to cart";
      }
    }

    page.querySelectorAll("[data-swatch]").forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        selectSwatch(swatch);
      });
    });

    page.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        page.querySelectorAll("[data-thumb]").forEach(function (el) {
          el.classList.remove("is-selected");
        });
        thumb.classList.add("is-selected");
        var image = thumb.getAttribute("data-image");
        if (image && mainImage) mainImage.setAttribute("src", image);
      });
    });
  });
})();
